import React from 'react';
import NavigationItem from './components/NavigationItem/NavigationItem';
import { ReactComponent as Home } from '@img/icons/home.svg';
import S from './Navigation.styles';
const Navigation = ({ items = [], homeUrl, isPortalHeader, onYsButtonClick, onYspButtonClick, endItem, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.List, { "data-is-portal": isPortalHeader },
            React.createElement(S.HomeIcon, { href: homeUrl },
                React.createElement(Home, null)),
            React.createElement(S.Spacer, null),
            items.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isPortalHeader: isPortalHeader ?? false, onYsButtonClick: onYsButtonClick, onYspButtonClick: onYspButtonClick }))),
            endItem)));
};
export default Navigation;
